import React from "react";
import {Col, Container, Nav, Navbar, Row} from "react-bootstrap";
import {Link, useParams} from "react-router-dom";


function Navigation() {
    let { runContext } = useParams();
    return (
        <Container style={{'margin':'10px 0'}}>
            <Row>
                <Col>
                    <nav pills="true">
                        <Nav variant="tabs" defaultActiveKey={runContext}>
                            <Nav.Item>
                                <Nav.Link href="generate" to={`/generate`} as={Link}>Generate</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href="performance" to={`/performance`} as={Link}>Indicator Performance</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href="harness" to={`/harness`} as={Link}>Backtest</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href="paper" to={`/paper`} as={Link}>Paper</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Navbar bg="light" expand="lg" hidden={runContext == "generate"}>
                            <Nav.Link  to={`/${runContext}/summary`} as={Link} >Order Summary</Nav.Link>
                              -
                            <Nav.Link to={`/${runContext}/chart`} as={Link}>Charted Results</Nav.Link>
                              -
                            <Nav.Link href="login" to="/login" as={Link} >Logout</Nav.Link>
                        </Navbar>
                    </nav>
                </Col>
            </Row>
        </Container>
    )
}
export {Navigation}
